"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const loadScript = (scriptToLoad, callback, delay) => {
  const load = () => {
    const scriptElement = document.createElement('script');
    scriptElement.src = scriptToLoad;
    // onload events aren't fired by jsdom so cant test this.
    /* istanbul ignore next */
    scriptElement.onload = callback;
    document.getElementsByTagName('body')[0].appendChild(scriptElement);
  };
  if (delay) {
    setTimeout(load, delay);
  } else {
    load();
  }
};
var _default = exports.default = loadScript;